import { sendGAEvent } from '@noths/polaris-client-google-analytics';
import { EventsMap } from '@noths/polaris-client-next-redux';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { carouselLinkClick, carouselVisible } from '../modules/actions';
import { CarouselCategoryClick, CarouselVisibleImpression } from './events';

export const GAEventsMap: EventsMap<ReduxApplicationState> = {
  [carouselVisible.type]: () => {
    sendGAEvent<CarouselVisibleImpression>({
      event: 'custom_event',
      event_category: 'Related Category',
      event_action: 'Impression',
      event_label: 'not set',
    });
  },
  [carouselLinkClick.type]: (_, __, action) => {
    const { payload } = action as ReturnType<typeof carouselLinkClick>;

    sendGAEvent<CarouselCategoryClick>({
      event: 'custom_event',
      event_category: 'Related Category',
      event_action: 'Link Click',
      event_label: payload.link.title!,
    });
  },
};
